import { render, staticRenderFns } from "./StartSection.vue?vue&type=template&id=151360f4&"
import script from "./StartSection.vue?vue&type=script&lang=js&"
export * from "./StartSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports